import { css } from 'styled-components'
import { f_0_75, f_0_875, f_1, f_1_25, f_1_5, f_2, f_3, f_4 } from './type-scale'
import { line_height_1_25, line_height_1_5 } from './typography'
import { proxima_nova } from './font'

export const h1_bold = () => css`
  font-size: ${f_2};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const h2_bold = () => css`
  font-size: ${f_1_5};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const h3_bold = () => css`
  font-family: ${proxima_nova};
  font-size: ${f_1_25};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const h4_bold = () => css`
  font-size: ${f_1};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const h5_bold = () => css`
  font-size: ${f_0_875};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const h6_bold = () => css`
  font-size: ${f_0_75};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const h1 = () => css`
  font-size: ${f_2};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const h2 = () => css`
  font-size: ${f_1_5};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const h3 = () => css`
  font-family: ${proxima_nova};
  font-size: ${f_1_25};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const h4 = () => css`
  font-size: ${f_1};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const h5 = () => css`
  font-size: ${f_0_875};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const h6 = () => css`
  font-size: ${f_0_75};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const body_large = () => css`
  font-size: ${f_1_25};
  font-weight: normal;
  line-height: ${line_height_1_5};
`

export const body = () => css`
  font-family: ${proxima_nova};
  font-size: ${f_1};
  font-weight: normal;
  line-height: ${line_height_1_5};
`

export const body_large_bold = () => css`
  font-size: ${f_1_25};
  font-weight: bold;
  line-height: ${line_height_1_5};
`

export const body_bold = () => css`
  font-size: ${f_1};
  font-weight: bold;
  line-height: ${line_height_1_5};
`

export const d1_bold = () => css`
  font-size: ${f_4};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const d2_bold = () => css`
  font-size: ${f_3};
  font-weight: bold;
  line-height: ${line_height_1_25};
`

export const d1 = () => css`
  font-size: ${f_4};
  font-weight: normal;
  line-height: ${line_height_1_25};
`

export const d2 = () => css`
  font-size: ${f_3};
  font-weight: normal;
  line-height: ${line_height_1_25};
`
